const cartSectionId = () => {
  const el = document.querySelector('site-cart')?.closest('[id^="shopify-section-"]');
  return el ? el.id.replace('shopify-section-', '') : 'cart-drawer';
};

const endpoints = {
  get: '/cart.json',
  add: '/cart/add.js',
  update: '/cart/update.js',
  change: '/cart/change.js',
};

window.formatMoney = (number) => {
  const shouldAddDigits = !Number.isInteger(number / 100);
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: window.currencySymbol || 'USD',
    maximumFractionDigits: shouldAddDigits ? 2 : 0,
  }).format(number / 100);
};

function updateCartCount(count) {
  document.querySelectorAll('cart-toggle').forEach(el => {
    el.setAttribute('count', count);
  });
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = `(${count})`;
  });
}

let cachedCart = null;

function gwpFindGiftItem(offer) {
  return cachedCart?.items?.find(i =>
    i.product_id === offer.giftProductId && i.properties?._gift
  );
}

function gwpHasQualifyingItem(offer, cart) {
  return (cart?.items || []).some(i =>
    offer.qualifyingVariantIds.includes(i.variant_id) &&
    (!offer.requireSubscription || i.selling_plan_allocation)
  );
}

async function gwpReconcile() {
  const offers = window.gwpOffers;
  if (!offers?.length) return false;

  cachedCart = await fetch(endpoints.get).then(r => r.json());

  const toAdd = [];
  const toRemove = {};
  offers.forEach(offer => {
    const qualifies = gwpHasQualifyingItem(offer, cachedCart);
    const giftItem = gwpFindGiftItem(offer);
    if (qualifies && !giftItem) {
      toAdd.push({ id: offer.giftVariantId, quantity: 1, properties: { _gift: offer.handle } });
    } else if (!qualifies && giftItem) {
      toRemove[String(giftItem.key)] = 0;
    }
  });

  if (!toAdd.length && !Object.keys(toRemove).length) return false;

  if (toAdd.length) {
    await fetch(endpoints.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: toAdd }),
    });
  }
  if (Object.keys(toRemove).length) {
    await fetch(endpoints.update, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: toRemove }),
    });
  }

  cachedCart = await fetch(endpoints.get).then(r => r.json());
  return true;
}

function gwpInterceptUpdate(data) {
  const offers = window.gwpOffers;
  if (!offers?.length || !cachedCart || !data.updates) return data;

  const updates = { ...data.updates };
  offers.forEach(offer => {
    const qualifyingItems = cachedCart.items.filter(i =>
      offer.qualifyingVariantIds.includes(i.variant_id) &&
      (!offer.requireSubscription || i.selling_plan_allocation)
    );
    if (!qualifyingItems.length) return;

    const allRemoved = qualifyingItems.every(i =>
      updates.hasOwnProperty(String(i.key)) && updates[String(i.key)] === 0
    );
    if (!allRemoved) return;

    const giftItem = gwpFindGiftItem(offer);
    if (giftItem) updates[String(giftItem.key)] = 0;
  });

  return { ...data, updates };
}

function parseSectionDoc(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}

async function postCart(data, endpoint, shouldOpen = false) {
  if (window.gwpOffers && endpoint === endpoints.update) {
    data = gwpInterceptUpdate(data);
  }

  const body = { ...data, sections: cartSectionId() };
  const resp = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await resp.json();

  if (!resp.ok) return json;

  const giftsChanged = await gwpReconcile();

  const siteCart = document.querySelector('site-cart');
  if (!siteCart) return json;

  if (giftsChanged) {
    const sections = await fetchSections();
    if (sections[cartSectionId()]) {
      siteCart.swapCartHTML(sections[cartSectionId()]);
    }
  } else if (json.sections && json.sections[cartSectionId()]) {
    siteCart.swapCartHTML(json.sections[cartSectionId()]);
  } else {
    const sections = await fetchSections();
    if (sections[cartSectionId()]) {
      siteCart.swapCartHTML(sections[cartSectionId()]);
    }
  }

  const cartData = await fetch(endpoints.get).then(r => r.json());
  cachedCart = cartData;
  updateCartCount(cartData.item_count);

  if (shouldOpen) siteCart.openCart();

  return json;
}

async function fetchSections() {
  const url = new URL(window.Shopify.routes.root, window.location.origin);
  url.searchParams.set('sections', cartSectionId());
  const resp = await fetch(url.toString(), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
  if (!resp.ok) return {};
  return resp.json();
}

window.addToCart = (data) => postCart(data, endpoints.add, true);
window.updateCart = (data) => postCart(data, endpoints.update, false);
window.changeCart = (data) => postCart(data, endpoints.change, false);

window.fetchCart = async (shouldOpen = true) => {
  const data = await fetch(endpoints.get).then(r => r.json());
  updateCartCount(data.item_count);
  window.cart = data;

  if (shouldOpen) {
    const siteCart = document.querySelector('site-cart');
    if (siteCart) siteCart.openCart();
  }

  return data;
};

window.toggleCart = (open) => {
  const siteCart = document.querySelector('site-cart');
  if (!siteCart) return;
  if (typeof open === 'boolean') {
    open ? siteCart.openCart() : siteCart.closeCart();
  } else {
    siteCart.isOpen ? siteCart.closeCart() : siteCart.openCart();
  }
};

class SiteCart extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.isOpen = false;
    this._openAnim = null;
    this._closeAnim = null;

    this.elBackdrop = this.querySelector('[data-cart-backdrop]');
    this.elPanel = this.querySelector('[data-cart-panel]');
    this.elInner = this.querySelector('[data-cart-inner]');
    this.elBody = this.querySelector('[data-cart-body]');
    this.elFooter = this.querySelector('[data-cart-footer]');
    this.elFloating = this.querySelector('[data-floating-checkout]');

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-close]')) this.closeCart();
    });
    this.elBackdrop?.addEventListener('click', () => this.closeCart());

    this._onKeyDown = (e) => {
      if (e.key === 'Escape' && this.isOpen) this.closeCart();
    };

    this.bindRemoveButtons();
    this.bindSubscribeButtons();
    this.bindUpgradeButtons();
    this.bindGwpOfferButton();
    this.bindCartOfferButton();
    this.initGwpOfferSlider();
    this.initFloatingCheckout();
    this.checkAutoOpen();

    fetch(endpoints.get)
      .then(r => r.json())
      .then(async data => {
        updateCartCount(data.item_count);
        window.cart = data;
        cachedCart = data;
        if (data.item_count > 0 && await gwpReconcile()) {
          const sections = await fetchSections();
          if (sections[cartSectionId()]) this.swapCartHTML(sections[cartSectionId()]);
          updateCartCount(cachedCart.item_count);
        }
      });
  }

  checkAutoOpen() {
    const url = new URL(window.location.href);
    if (url.searchParams.get('cart') !== 'true') return;

    const open = () => {
      this.openCart();
      url.searchParams.delete('cart');
      window.history.replaceState({}, '', url);
    };

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      open();
    } else {
      window.addEventListener('DOMContentLoaded', open, { once: true });
    }
  }

  openCart() {
    if (this.isOpen) return;
    this.isOpen = true;

    if (this._closeAnim) {
      this._closeAnim.cancel();
      this._closeAnim = null;
    }

    this.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this._onKeyDown);

    this.elBackdrop.animate(
      [{ opacity: 0 }, { opacity: 1 }],
      { duration: 300, fill: 'forwards' }
    );

    this._openAnim = this.elPanel.animate(
      [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
      { duration: 350, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' }
    );

    this.initFloatingCheckout();
  }

  closeCart() {
    if (!this.isOpen) return;
    this.isOpen = false;

    if (this._openAnim) {
      this._openAnim.cancel();
      this._openAnim = null;
    }

    document.removeEventListener('keydown', this._onKeyDown);

    this.elBackdrop.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      { duration: 300, fill: 'forwards' }
    );

    this._closeAnim = this.elPanel.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }],
      { duration: 300, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
    );

    this._closeAnim.onfinish = () => {
      this.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
      this._closeAnim = null;
    };
  }

  swapCartHTML(sectionHTML) {
    const doc = parseSectionDoc(sectionHTML);

    ['[data-cart-main]', '[data-cart-extra-buttons]', '[data-floating-checkout]'].forEach(sel => {
      const fresh = doc.querySelector(sel);
      const current = this.querySelector(sel);
      if (fresh && current) {
        current.replaceWith(fresh);
      } else if (fresh && !current) {
        this.querySelector('[data-cart-inner]')?.appendChild(fresh);
      } else if (!fresh && current) {
        current.remove();
      }
    });

    this.elBody = this.querySelector('[data-cart-body]');
    this.elFooter = this.querySelector('[data-cart-footer]');
    this.elFloating = this.querySelector('[data-floating-checkout]');

    this.bindRemoveButtons();
    this.bindSubscribeButtons();
    this.bindUpgradeButtons();
    this.bindGwpOfferButton();
    this.bindCartOfferButton();
    this.initGwpOfferSlider();
    this.initFloatingCheckout();
  }

  bindRemoveButtons() {
    this.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const key = btn.getAttribute('data-cart-remove');
        btn.closest('[data-cart-item]')?.classList.add('opacity-50', 'pointer-events-none');
        window.updateCart({ updates: { [key]: 0 } });
      });
    });
  }

  bindSubscribeButtons() {
    this.querySelectorAll('[data-subscribe-convert]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const itemKey = btn.dataset.itemKey;
        const variantId = parseInt(btn.dataset.variantId, 10);
        const sellingPlanId = parseInt(btn.dataset.sellingPlanId, 10);
        const quantity = parseInt(btn.dataset.quantity, 10) || 1;

        btn.closest('[data-cart-item]')?.classList.add('opacity-50', 'pointer-events-none');

        const existingSubItem = cachedCart?.items?.find(i =>
          i.variant_id === variantId && i.selling_plan_allocation
        );

        if (existingSubItem) {
          await window.updateCart({
            updates: {
              [itemKey]: 0,
              [String(existingSubItem.key)]: existingSubItem.quantity + quantity,
            },
          });
        } else {
          await fetch(endpoints.update, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [itemKey]: 0 } }),
          });

          await postCart(
            { id: variantId, quantity, selling_plan: sellingPlanId },
            endpoints.add
          );
        }
      });
    });
  }

  bindUpgradeButtons() {
    this.querySelectorAll('[data-upgrade-plan]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const itemKey = btn.dataset.itemKey;
        const variantId = parseInt(btn.dataset.variantId, 10);
        const sellingPlanId = parseInt(btn.dataset.sellingPlanId, 10);
        const quantity = parseInt(btn.dataset.quantity, 10) || 1;

        btn.closest('[data-cart-item]')?.classList.add('opacity-50', 'pointer-events-none');

        const removals = { [itemKey]: 0 };
        if (window.gwpOffers?.length && cachedCart) {
          window.gwpOffers.forEach(offer => {
            const giftItem = gwpFindGiftItem(offer);
            if (giftItem) {
              removals[String(giftItem.key)] = 0;
            }
          });
        }

        await fetch(endpoints.update, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: removals }),
        });

        cachedCart = await fetch(endpoints.get).then(r => r.json());

        await postCart(
          { id: variantId, quantity, selling_plan: sellingPlanId },
          endpoints.add
        );
      });
    });
  }

  bindCartOfferButton() {
    this.querySelectorAll('[data-cart-offer-add]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId) return;
        btn.classList.add('opacity-50', 'pointer-events-none');
        await postCart({ id: variantId, quantity: 1 }, endpoints.add);
      });
    });
  }

  bindGwpOfferButton() {
    this.querySelectorAll('[data-gwp-offer-add]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = parseInt(btn.dataset.variantId, 10);
        const sellingPlanId = parseInt(btn.dataset.sellingPlanId, 10);
        const offer = (window.gwpOffers || []).find(o => o.handle === btn.dataset.offerHandle);

        btn.classList.add('opacity-50', 'pointer-events-none');

        if (offer && cachedCart) {
          const onetimeItem = cachedCart.items.find(i =>
            offer.qualifyingVariantIds.includes(i.variant_id) && !i.selling_plan_allocation
          );
          if (onetimeItem) {
            await fetch(endpoints.update, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: { [String(onetimeItem.key)]: 0 } }),
            });
          }
        }

        await postCart(
          { id: variantId, quantity: 1, selling_plan: sellingPlanId },
          endpoints.add
        );
      });
    });
  }

  initGwpOfferSlider() {
    const track = this.querySelector('[data-gwp-offer-track]');
    const dots = this.querySelectorAll('[data-gwp-offer-dot]');
    if (!track || !dots.length) return;

    const slides = track.querySelectorAll('[data-gwp-offer-slide]');

    const setActive = (idx) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('bg-burnt-orange', i === idx);
        dot.classList.toggle('bg-burnt-orange/30', i !== idx);
      });
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const slide = slides[i];
        if (slide) {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft });
          setActive(i);
        }
      });
    });

    track.addEventListener('scroll', () => {
      clearTimeout(this._gwpSliderScrollId);
      this._gwpSliderScrollId = setTimeout(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(idx, dots.length - 1)));
      }, 80);
    }, { passive: true });
  }

  initFloatingCheckout() {
    if (this._floatingCleanup) {
      this._floatingCleanup();
      this._floatingCleanup = null;
    }

    const floating = this.elFloating || this.querySelector('[data-floating-checkout]');
    const sentinel = this.querySelector('[data-cart-subtotal-sentinel]');
    const scrollRoot = this.elBody || this.querySelector('[data-cart-body]');

    if (!floating || !sentinel || !scrollRoot) return;
    if (window.matchMedia('(min-width: 1024px)').matches) {
      floating.classList.add('translate-y-full');
      return;
    }

    floating.classList.remove('translate-y-full');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          floating.classList.add('translate-y-full');
        } else {
          floating.classList.remove('translate-y-full');
        }
      },
      { root: null, threshold: 0 }
    );

    observer.observe(sentinel);

    const onResize = () => {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        floating.classList.add('translate-y-full');
      }
    };
    window.addEventListener('resize', onResize);

    this._floatingCleanup = () => {
      observer.disconnect();
      window.removeEventListener('resize', onResize);
    };
  }
}

customElements.define('site-cart', SiteCart);
